import styled from 'styled-components';

const StyledDivider = styled.div.attrs({
	className: 'fuse-divider',
	'data-testid': 'fuse-divider',
})`
	${({ color, size }) => `
		border: 0;
		border-bottom: ${size} solid ${color};
		margin: 0;
		width: 100%;
	`}
`;

export default StyledDivider;
